import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './style/video.module.css';

export default class Video extends React.Component {
  componentDidMount() {
    if (this.props.id) {
      const jsonp = document.createElement('script');
      const script = document.createElement('script');

      jsonp.src = `https://fast.wistia.com/embed/medias/${this.props.id}.jsonp`;
      jsonp.async = true;

      script.src = 'https://fast.wistia.com/assets/external/E-v1.js';
      script.async = true;

      document.body.appendChild(jsonp);
      document.body.appendChild(script);
    }
  }

  render() {
    if (this.props.childButton) {
      return (
        <div
          className={cx(
            styles.video,
            `wistia_async_${this.props.id}`,
            `popoverContent=html`
          )}
          style={this.props.style}
        >
          {this.props.childButton}
        </div>
      );
    }
    return (
      <div className={styles.wrapper}>
        <div className={styles.inner}>
          <div className={cx(styles.video, `wistia_async_${this.props.id}`)}>
            &nbsp;
          </div>
        </div>
      </div>
    );
  }
}

Video.propTypes = {
  id: PropTypes.string,
  style: PropTypes.object,
  childButton: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/modules/Integrations/Video.js